import { GridColDef, GridApi } from "@mui/x-data-grid";
import React from 'react'

export type GridApiRefProps = {
  apiRef: React.RefObject<GridApi>;
  columns: GridColDef[];
}

/**
 * 此方法可以取得操控整個 DataGrid 動作的 apiRef
 * 原本可以使用商用進階版 DataGridPro 與 DataGridPremium 取得 licence 後開放進階功能
 * 目前單純拿出來控制 SelectRow 的位置
 * 
 * [HACK] 注意! 此方法並非官方公開的 API，而是強制記憶 DataGrid 的 API
 * !! 未來版本有被官方防止使用此方法的可能 !!
 * 至少這個版本可用 "@mui/x-data-grid": "^5.17.13"
 * 
 * 參考: https://codesandbox.io/s/70003754-how-to-make-edit-and-focus-on-a-material-uis-row-with-an-onclick-event-bjyk0?file=/demo.tsx:192-562
 * 原理: 
 * 在產生的 Column 定義檔 最後偷加一個看不到的欄位
 * 並在內部設定 apiRef 時攔截記下來並回傳，以便之後使用
 * 
 * useGridApiRef
 */
export function useGridApiRef(col_defines: GridColDef[]): GridApiRefProps {

  const apiRef: React.RefObject<GridApi> = React.useRef<GridApi>(null);

  const FIELD_NAME = ' ';

  function create_ColDefine() {
    // 偷偷在原本最後面加上隱藏的欄位             
    return {
      // flex:1,

      field: FIELD_NAME,
      width: 0,// 就算露出來，也看不到
      minWidth: 0,
      hideable: false,
      filterable: false,
      sortable: false,
      // aggregable: false,
      resizable: false,
      // hide: true,// 5.0 還有效果，之後6.0預計就不可用這個屬性隱藏

      renderCell: (params: any) => {
        (apiRef as any).current = params.api;
        return null;// <div></div>
      }
    }
  }

  const columns = React.useMemo(
    () => {
      /* 嚴格模式時可能會觸發兩次，先移除之前的再加入 */
      col_defines = [...col_defines.filter(x => x.field !== FIELD_NAME)];

      col_defines.unshift(create_ColDefine());
      return col_defines;
    },
    [col_defines],
  );

  return { apiRef, columns };
}